import AddCargoOperationPage from "@features/drybulk-cargo-operations/components/AddCargoOperationPage";
import DrybulkCargoOperationDetail from "@features/drybulk-cargo-operations/components/DrybulkCargoOperationDetail";
import ImportDeferredPage from "@features/drybulk-cargo-operations/components/ImportDeferredPage";
import OperationManagementPage from "@features/drybulk-cargo-operations/components/OperationManagementPage";
import SequenceDetailsPage from "@features/drybulk-cargo-operations/components/SequenceDetailsPage";
import StandalonePage from "@features/drybulk-cargo-operations/components/StandalonePage";
import {
  DRYBULK_CARGO_OPS_ACCESS_PERMISSION,
  DRYBULK_CARGO_OPS_ROUTE_SEGMENTS,
} from "@features/drybulk-cargo-operations/constants";
import DrybulkCargoOperationsContainer from "@features/drybulk-cargo-operations/DrybulkCargoOperationsContainer";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

export const getDrybulkCargoOperationsRoutes = (): AppRoute => ({
  path: paths.drybulkCargoOperations.index,
  protected: true,
  element: <DrybulkCargoOperationsContainer />,
  requiredPermissions: [DRYBULK_CARGO_OPS_ACCESS_PERMISSION],
  children: [
    { index: true, element: <OperationManagementPage /> },
    {
      path: paths.drybulkCargoOperations.add,
      element: (
        <StandalonePage>
          <AddCargoOperationPage />
        </StandalonePage>
      ),
    },
    {
      path: paths.drybulkCargoOperations.importDeferred,
      element: (
        <StandalonePage>
          <ImportDeferredPage />
        </StandalonePage>
      ),
    },
    {
      path: ":operationId",
      element: (
        <StandalonePage>
          <DrybulkCargoOperationDetail />
        </StandalonePage>
      ),
      children: [
        {
          path: `${DRYBULK_CARGO_OPS_ROUTE_SEGMENTS.sequence}/:sequenceId`,
          element: <SequenceDetailsPage />,
        },
      ],
    },
  ],
});
